import React from "react";
import { Link, useParams } from "react-router-dom";
import MoreOptionsCard from "../../../Components/Utils/MoreOptionsCard";

const EmployeeCard = ({ item, key, fetcher, data }) => {
  const { officeId } = useParams();
  return (
    <div
      key={key}
      className="w-full md:w-[30%] lg:w-[23%] bg-white p-2 rounded shadow-md border-blue-100 border"
    >
      <div className="w-full flex">
        <div className="w-11/12">
          <div className="w-full flex justify-start gap-2">
            <div className="w-[15%]">
              <div className=" text-sm w-8 h-8 bg-slate-300 rounded-full overflow-hidden mt-0.5 flex items-center justify-center">
                {item?.imageUrl
                  ? item?.imageUrl && (
                      <img
                        src={item.imageUrl}
                        width="35px"
                        alt={`${item?.imageUrl?.file}`}
                        className="object-cover"
                      />
                    )
                  : item?.name[0]}
              </div>
            </div>
            <div className="w-[80%] flex flex-col">
              <p className=" text-[14px] font-medium  text-[#4F4768] truncate w-32">
                <Link
                  to={`/main/${officeId}/employees/view/${item?.employeeId}`}
                  state={{ data: item }}
                >
                  {item?.name || "-"}
                </Link>
              </p>
              <p className="text-[#9A95A8] text-xs font-normal break-all truncate">
                Employee ID: {item?.employeeId || "-"}
              </p>
            </div>
          </div>
        </div>
        <div className="w-1/12 flex justify-end">
          <MoreOptionsCard
            data={item}
            fetcher={fetcher}
            id={item?.employeeId}
            removevalue={item?.name || "undefined"}
            url={`/employees/`}
            moduleName={"Employee"}
            from={`/main/${officeId}/employees/`}
            editLink={`/main/${officeId}/employees/edit/`}
            viewLink={`/main/${officeId}/employees/view/`}
          />
        </div>
      </div>
      <div className="w-full flex justify-end">
        {/* <div>
              <span>Role:</span><p>{role || ''}</p>
            </div> */}
        {item?.isActive === true ? (
          <div className="w-2 h-2 bg-[#08B624] rounded-full flex justify-end"></div>
        ) : item?.isActive === false ? (
          <div className="w-2 h-2 bg-[#FF3232] rounded-full flex justify-end"></div>
        ) : (
          <div className="w-2 h-2 bg-slate-300 rounded-full flex justify-end"></div>
        )}
      </div>
      <div className="w-full rounded p-2 mt-2 bg-[#f5f3ff]">
        <div className="w-full flex flex-col gap-y-1">
          <div className="flex justify-start gap-x-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
            >
              <path
                d="M6.55013 8.32137L9.67513 10.8214C9.97073 11.058 10.3381 11.187 10.7168 11.187C11.0955 11.187 11.4629 11.058 11.7585 10.8214L14.8835 8.32137M18.2168 14.988V6.6547C18.2168 6.21268 18.0412 5.78875 17.7286 5.47619C17.4161 5.16363 16.9922 4.98804 16.5501 4.98804H4.88346C4.44144 4.98804 4.01751 5.16363 3.70495 5.47619C3.39239 5.78875 3.2168 6.21268 3.2168 6.6547V14.988C3.2168 15.4301 3.39239 15.854 3.70495 16.1665C4.01751 16.4791 4.44144 16.6547 4.88346 16.6547H16.5501C16.9922 16.6547 17.4161 16.4791 17.7286 16.1665C18.0412 15.854 18.2168 15.4301 18.2168 14.988Z"
                stroke="#7D77B1"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <p className="text-xs font-normal text-[#6C6580] truncate group">
              {item?.email || "-"}
            </p>
          </div>
          <div className="flex justify-start gap-x-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
            >
              <path
                d="M16.241 18.3213H16.0437C13.8214 18.0795 11.6863 17.3218 9.80874 16.1086C8.06447 14.9977 6.58351 13.5196 5.46912 11.7775C4.25313 9.89504 3.4953 7.75373 3.25643 5.52541C3.22911 5.25962 3.25608 4.99106 3.33569 4.73602C3.4153 4.48097 3.54589 4.24475 3.71955 4.0417C3.88845 3.83593 4.09693 3.66614 4.33263 3.5424C4.56833 3.41865 4.82647 3.34347 5.09176 3.32129H7.32161C7.80455 3.32178 8.27141 3.49493 8.63786 3.80949C9.00432 4.12404 9.24622 4.55926 9.31989 5.03656C9.40132 5.64966 9.55386 6.25119 9.77444 6.82901C9.90861 7.19211 9.9363 7.58598 9.85426 7.96429C9.77221 8.3426 9.58385 8.68961 9.31132 8.96451L8.78816 9.48767C9.61185 10.788 10.7167 11.887 12.0214 12.7038L12.5446 12.1892C12.8195 11.9167 13.1665 11.7283 13.5448 11.6463C13.9231 11.5642 14.317 11.5919 14.6801 11.7261C15.2586 11.9446 15.8599 12.0971 16.4726 12.1806C16.958 12.2536 17.4001 12.5012 17.7159 12.8771C18.0317 13.2529 18.1995 13.731 18.1878 14.2218V16.2801C18.1878 16.8154 17.9758 17.329 17.598 17.7083C17.2203 18.0876 16.7077 18.3019 16.1724 18.3041L16.241 18.3213ZM7.32161 4.59916H5.27187C5.17122 4.60582 5.07297 4.63281 4.98305 4.6785C4.89313 4.7242 4.81341 4.78765 4.74871 4.86503C4.68573 4.93751 4.63807 5.02198 4.6086 5.11336C4.57912 5.20474 4.56843 5.30114 4.57718 5.39676C4.78515 7.41801 5.46365 9.36245 6.55831 11.0743C7.56744 12.6581 8.91107 14.0017 10.4948 15.0108C12.2078 16.117 14.1543 16.8099 16.181 17.0348C16.2864 17.0408 16.3918 17.0248 16.4907 16.9879C16.5897 16.951 16.6798 16.894 16.7556 16.8204C16.8921 16.6804 16.969 16.4929 16.97 16.2973V14.2475C16.9738 14.067 16.9114 13.8914 16.7944 13.7539C16.6774 13.6164 16.5141 13.5265 16.3353 13.5014C15.6268 13.4061 14.9308 13.2336 14.2599 12.9868C14.1277 12.9374 13.9842 12.9265 13.846 12.9553C13.7079 12.9842 13.5808 13.0516 13.4794 13.1498L12.6218 14.0074C12.5213 14.1053 12.392 14.1682 12.2529 14.1868C12.1138 14.2053 11.9725 14.1785 11.8499 14.1103C10.0199 13.0762 8.50511 11.5644 7.46741 9.73638C7.39638 9.61457 7.36793 9.47258 7.38657 9.33281C7.40521 9.19304 7.46986 9.06346 7.57032 8.96451L8.42795 8.10688C8.52631 8.00742 8.59397 7.88175 8.62286 7.74489C8.65175 7.60803 8.64066 7.46574 8.5909 7.33501C8.34321 6.66433 8.17063 5.96825 8.07632 5.25954C8.05505 5.07538 7.96597 4.90573 7.82645 4.78365C7.68693 4.66157 7.50697 4.59581 7.32161 4.59916Z"
                fill="#7D77B1"
              />
            </svg>
            <p className="text-xs font-normal text-[#6C6580]">
              {item?.country_code && `+${item?.country_code}` } {item?.mobileNo}
            </p>
          </div>
          <div className="flex justify-start gap-x-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
            >
              <path
                d="M15.2909 14.3647L11.7729 17.8837C11.6342 18.0224 11.4696 18.1325 11.2885 18.2076C11.1073 18.2826 10.9131 18.3213 10.717 18.3213C10.5208 18.3213 10.3266 18.2826 10.1455 18.2076C9.96429 18.1325 9.79968 18.0224 9.66105 17.8837L6.143 14.3647C5.54227 13.764 5.06573 13.0509 4.7406 12.2661C4.41546 11.4812 4.24809 10.6401 4.24805 9.79056C4.248 8.94105 4.41528 8.09985 4.74033 7.31498C5.06538 6.53012 5.54184 5.81697 6.1425 5.21624C6.74316 4.61551 7.45626 4.13898 8.24109 3.81384C9.02592 3.4887 9.8671 3.32134 10.7166 3.32129C11.5661 3.32124 12.4073 3.48852 13.1922 3.81357C13.977 4.13862 14.6902 4.61508 15.2909 5.21574C15.8917 5.81644 16.3683 6.5296 16.6934 7.31449C17.0186 8.09938 17.1859 8.94063 17.1859 9.79021C17.1859 10.6398 17.0186 11.481 16.6934 12.2659C16.3683 13.0508 15.8917 13.764 15.2909 14.3647ZM14.236 6.27166C13.3027 5.33835 12.0369 4.81302 10.717 4.81302C9.39706 4.81302 8.13123 5.33735 7.19792 6.27066C6.26461 7.20397 5.74028 8.46981 5.74028 9.78971C5.74028 11.1096 6.26461 12.3754 7.19792 13.3088L10.717 16.8268L14.236 13.3098C14.6982 12.8477 15.0649 12.2991 15.315 11.6953C15.5652 11.0914 15.6939 10.4443 15.6939 9.7907C15.6939 9.13713 15.5652 8.48996 15.315 7.88616C15.0649 7.28235 14.6982 6.73374 14.236 6.27166ZM10.717 11.7811C10.4519 11.7871 10.1883 11.7401 9.94167 11.6428C9.69503 11.5455 9.47031 11.4 9.28071 11.2146C9.0911 11.0293 8.94043 10.808 8.83754 10.5636C8.73465 10.3193 8.68162 10.0568 8.68155 9.79171C8.68149 9.52658 8.73439 9.26411 8.83716 9.01971C8.93992 8.7753 9.09048 8.55389 9.28 8.36848C9.46951 8.18306 9.69416 8.03738 9.94075 7.93998C10.1873 7.84258 10.4509 7.79543 10.716 7.80129C11.236 7.81279 11.7309 8.02742 12.0947 8.39925C12.4585 8.77107 12.6622 9.27053 12.6624 9.79071C12.6625 10.3109 12.459 10.8105 12.0954 11.1825C11.7318 11.5545 11.237 11.7694 10.717 11.7811Z"
                fill="#7D77B1"
              />
            </svg>
            <p className="text-xs font-normal text-[#6C6580]">
              {item?.city || "-"} {item?.pincode && `, ${item?.pincode}` }
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeCard;
